<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="'일괄 메일 발송'"
      :modal="true"
      :width="'400px'"
      style="z-index: 10004; transform: scale(1); opacity: 1; display:none;"
  >
    <div>
      <ul class="filter_list w100">
        <li>배송 완료 메일을 함께 발송하시겠습니까?</li>
        <li><span class="forg">*수신 정보에 입력된 이메일 주소로 메일이 발송됩니다.<br>
         (단, DX사업장과 ESOP의 경우 메일이 발송되지 않습니다.)</span></li>
        <li>
          <div v-for="item in [{nm: '발송', id:'Y'}, {nm: '발송하지 않음', id:'N'}]">
            <input
                class="k-radio"
                name="sendMailYn"
                type="radio"
                :id="`${item.id}_sendMail1Yn1`"
                @change="sendMailYn = item.id">
            <label :for="`${item.id}_sendMail1Yn1`" class="k-radio-label" style="width:90px;">{{item.nm}}</label>
          </div>
        </li>
      </ul>
    </div>
    <div class="button_area w50">
      <ul>
        <li class="w50"><button class="large_btn orange" @click="getSendMailYn">확인</button></li>
        <li class="w50"><button class="large_btn" @click="onClickCloseWindow">취소</button></li>
      </ul>
    </div>
  </kendo-window>
</template>

<script>
import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";

export default {
  name: "SendMailYn",
  props: {
    batchList : {
      type : Array,
      required : true,
      default : function (){
        return []
      }
    },
  },
  methods: {
    getSendMailYn () {
      const vm = this
      // 메일 발송
      if(!!vm.sendMailYn && vm.sendMailYn === 'N'){
        this.$emit('afterSendMail', 'N')
        vm.onClickCloseWindow()
      } else {
        const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/sendPouchReceiveMail.json`
        const params = {
          loginUserToken: vm.loginUserToken,
          pouchIdList: vm.batchList
        }

        // API 호출
        ApiUtil.post(url, params).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            // kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            return false
          }

          this.$emit('afterSendMail', 'Y')
          vm.onClickCloseWindow()
        })
      }
    },

    onClickCloseWindow () {
      this.$refs.kendoWindowRef.kendoWidget().close()
    }
  },
  data () {
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      sendMailYn: null,
    }
  }
}
</script>

<style scoped>

</style>